export const R_HOME = 1
export const R_DASHBOARD = 2
export const R_USER_SETTINGS = 3
export const R_LOGIN = 4
export const R_APPLICANTS = 5
export const R_APPLICANT = 6
export const R_APPLICANT_BASIC = 7
export const R_APPLICANT_BASIC_VIEW = 8
export const R_APPLICANT_NEW = 9
export const R_RECOGNITION_DATA = 10
export const R_APPLICANT_DOCUMENT = 11
export const R_USER_LIST = 12
export const R_INSTITUTIONS = 13
export const R_RESET_PASSWORD = 14
export const R_CONTACTS = 15
export const R_RECOGNITION_DECISION_DOCUMENT = 42
export const R_LOGS = 43
